import * as apiClient from "./httpCommon";
import { apiRoutes } from "../helper";

export const getReportById = async (data) => (await apiClient.postAPICall(apiRoutes.progressReports.getReportById, data)).data;
export const getReportsByPupilId = async (data) => (await apiClient.postAPICall(apiRoutes.progressReports.getReportsByPupilId, data)).data;
export const saveReport = async (data) => (await apiClient.postAPICall(apiRoutes.progressReports.saveReport, data)).data;